import * as Bowser from 'bowser';

const browser = Bowser.getParser(window.navigator.userAgent);

export const isMobile = () => browser.getPlatformType() === 'mobile';

export const isSafari = () =>
  browser.satisfies({
    safari: '>3.1',
  });

export const isIE = () =>
  browser.satisfies({
    ie: '>6',
  });

export const isIOS = () => browser.getOSName() === 'iOS';

export const isTouchDevice = () =>
  browser.getPlatformType() === 'mobile' || browser.getPlatformType() === 'tablet';
